module.exports = __webpack_public_path__ + "static/logo-gold-a953a783bfdcea14e431d5e93bb9759e.png";